export const blockIconsMapsMyLocationNew = (
	<span className='material-symbols-outlined'>my_location</span>
);
